import './Dashboard.scss'
import './Header.scss'
import './TrainingCenter.scss'

import { getEmbeddedFeatureFlags } from 'manager/redux/dashboard'
import React, { Component } from 'react';
import { show as showModal } from 'redux-modal'
import HelpModal from './HelpModal'
import client from 'common/util/http'
import { push, replace } from 'react-router-redux'
import { isEmbedded, deviceType, isHeaderHidden } from 'common/util/features'
import { newlineToBreak } from 'common/util/helper'
import { ANDROID, APPLE } from 'common/constants'
import { CongratsClosedModal } from 'manager/views/components/ReferralStatus/CongratsClosedModal'
import { BackwardStatusWarningModal } from 'manager/views/components/ReferralStatus/BackwardStatusWarningModal'
import { StatusChangedModal } from 'manager/views/components/ReferralStatus/StatusChangedModal'
import { setAgentOnboardDate } from 'manager/redux/settings'
import { loadFeatures } from 'common/redux/auth'
import ConfirmMetStatusModal from 'manager/views/components/Referral/ConfirmMetStatusModal'

class Dashboard extends Component {

  componentDidMount() {
    this.props.dispatch(loadFeatures())
    this.props.dispatch(getEmbeddedFeatureFlags())

    if (!isEmbedded()) {
      setTimeout(()=> {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(position => {
            client.post('agent_location', {
              data: {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              }
            })
          })
        }
      }, 3000)
    }
  }

  componentDidUpdate() {
    this._div.scrollTop = 0
  }

  render() {
    const { dispatch, children, params } = this.props
    const { hash } = params

    function handleBack() {
      if (location.pathname === '/settings') {
        dispatch(push({pathname:'/'}))
      } else if (location.pathname === '/settings/blocked-zipcodes-area') {
        dispatch(replace({pathname:'/settings/blocked-zipcodes'}))
      } else if (location.pathname.includes('title_and_escrow_details')) {
        dispatch(replace({pathname:`/referral/${hash}`}))
      } else {
        window.history.back()
      }
    }

    function handleHelp() {
      dispatch(showModal("HelpModal", { setAgentOnboardDate: () => dispatch(setAgentOnboardDate()), goToAgentTrainingCenter }))
    }

    function handleSettings() {
      dispatch(push({pathname:'/settings'}))
    }

    function goToAgentTrainingCenter() {
      dispatch(push({pathname:'/training'}))
    }

    function getBannerTextClass(whiteBanner) {
      const platformClass = isAndroid ? 'android' : (isApple ? 'apple' : null)
      headerClass += platformClass ? ` Dashboard__header_${platformClass}` : ''
      contentClass += platformClass ? ` Dashboard__content_${platformClass}` : ''
      let leftClass = "Dashboard__left" + (platformClass ? ` Dashboard__left_${platformClass}` : '')
      let rightClass = "Dashboard__right" + (platformClass ? ` Dashboard__right_${platformClass}` : '')
      if (whiteBanner) {
        leftClass += " Dashboard__white_banner_text_color"
        rightClass += " Dashboard__white_banner_text_color"
      }
      return {platformClass, leftClass, rightClass}
    }

    const embedded = isEmbedded()
    const showHeader = !isHeaderHidden()
    const isAndroid = embedded && deviceType() == ANDROID
    const isApple = embedded && deviceType() == APPLE
    const urlParams = new URLSearchParams(location.search)
    const standalone = urlParams.get("standalone")

    let backButton = location.pathname === '/' || (location.pathname === '/settings' && embedded) || standalone === 'true' ? null : <span className="clickable" onClick={handleBack}><i className="fa fa-chevron-left" aria-hidden="true"></i></span>

    const helpButton = location.pathname === '/' ? <div className="Dashboard__help clickable" onClick={handleHelp}><i className="fa fa-question-circle-o" aria-hidden="true"></i></div> : null

    const trainingCenterTitle = _.startsWith(location.pathname, '/training') ? <div className="TrainingCenter"><div className="TrainingCenter__training__title">Training Center</div> </div> : null

    let settingsButton = (
        <span className="clickable" onClick={handleSettings}>
          <i className="fa fa-cog" aria-hidden="true"></i>
        </span>
    )
    let hideSettingsButton = _.startsWith(location.pathname, '/settings') || _.startsWith(location.pathname, '/training') || embedded

    let headerClass
    let contentClass
    if (this.props.root.agreementBanner) {
      headerClass = "Dashboard__header Dashboard__header_agreement_banner"
      contentClass = "Dashboard__content Dashboard__content_agreement_banner"
    } else if (this.props.root.banner) {
      headerClass = "Dashboard__header Dashboard__header_banner"
      contentClass = "Dashboard__content Dashboard__content_banner"
    } else if(this.props.root.infoBanner) {
      headerClass = "Dashboard__header Dashboard__header_info_banner"
      contentClass = "Dashboard__content Dashboard__content_info_banner"
    } else if(this.props.root.whiteBanner) {
      headerClass = "Dashboard__header Dashboard__header_white_banner"
      contentClass = "Dashboard__content Dashboard__content_white_banner"
    } else {
      headerClass = "Dashboard__header"
      contentClass = "Dashboard__content"
    }

    const {platformClass, leftClass, rightClass} = getBannerTextClass(this.props.root.whiteBanner)

    let title = <div className="Header"><div className="Header__image"/><div className="Header__text">Referrals</div> </div>
    let name
    if (this.props.root.title) {
      let titleClass = "Dashboard__title" + (isApple ? " Dashboard__title_apple" : "")
      let nameClass = titleClass

      if (this.props.root.whiteBanner) {
        titleClass += " Dashboard__white_banner_title"
        nameClass += " Dashboard__white_banner_name"
      }

      title = <div className={titleClass}>{ this.props.root.title }</div>

      if (this.props.root.name) {
        name = <div className={nameClass}>{ this.props.root.name }</div>
      }
    } else if (platformClass) {
      title = <div className={`Dashboard__logo Dashboard__logo_image Dashboard__logo_${platformClass}`}/>
    }

    let banner
    if (this.props.root.banner) {
      banner = <div className="Dashboard__banner">{ newlineToBreak(this.props.root.banner, false) }</div>
    } else if(this.props.root.infoBanner) {
      banner = <div className="Dashboard__info_banner">{ this.props.root.infoBanner }</div>
    }

    return (
      <div className={`Dashboard ${showHeader ? '' : 'Dashboard__no-header'}`}>
          { showHeader && banner }
          { showHeader &&
            <div className={headerClass}>
              <div className={leftClass}>
                { backButton }
              </div>
              <div className={rightClass} style={{visibility: hideSettingsButton ? "hidden" : "visible"}}>
                { settingsButton }
                { helpButton }
              </div>
                <div>
                  { trainingCenterTitle }
                  <div>
                    { !trainingCenterTitle ? title : null }
                  </div>
                </div>
                { name }
            </div>
          }
        <div ref={(ref) => this._div = ref} className={contentClass}>
          { children }
        </div>
        <HelpModal />
        <CongratsClosedModal />
        <BackwardStatusWarningModal />
        <StatusChangedModal />
        <ConfirmMetStatusModal />
      </div>
    )
  }
}

export default Dashboard
